import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 100px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
`

export const FormField = styled(Container)`
  flex: 1;
  justify-content: flex-end;
  padding: 0px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 16px;
  text-align: center;
  margin: 0px;
`

export const WhiteText = styled(InfoText)`
  color: #FFFFFF;
  margin: 0px;
  font-size: 14px;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  margin: 0px;

  &:hover {
    cursor: pointer;
  }
`

export const Input = styled(BaseInput)`
  width: 100%;
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`
